/**
 * "Back to globe" for the twin HUD while a dive is in the twin (disabled while
 * the return runs), with what the dish follows and its pointing on two short
 * lines so the identity card keeps its width.
 */
import { useNavigate } from 'react-router';
import { Globe2 } from 'lucide-react';
import { TextButton } from '@/components/ui/primitives';
import { returnToGlobe } from './controller';
import { createDiveDeps } from './deps';
import { useDive } from './store';

export function DiveReturn() {
  const navigate = useNavigate();
  const phase = useDive((s) => s.phase);
  const site = useDive((s) => s.site);
  const track = useDive((s) => s.track);
  if (phase !== 'twin' && phase !== 'returning') return null;

  const pointing = track ? `az ${track.azimuthDeg.toFixed(1)}, el ${track.elevationDeg.toFixed(1)}` : null;
  return (
    <div className="flex flex-col items-start gap-0.5 border-t border-hairline pt-1.5">
      <TextButton
        onClick={() => void returnToGlobe(createDiveDeps((path) => navigate(path)))}
        disabled={phase === 'returning'}
        title="Fly back out to the globe"
        className="-ml-1 flex items-center gap-1"
      >
        <Globe2 className="h-3.5 w-3.5" aria-hidden />
        Back to globe
      </TextButton>
      {track && (
        <div className="max-w-[220px] text-[10px] leading-4 text-ink-3" title={`${site?.name ?? ''}: dish ${track.label}, ${pointing}`} data-testid="dive-track">
          <div className="truncate">
            {site?.shortName} dish {track.label}
          </div>
          <div className="font-mono text-ink-2">{pointing}</div>
        </div>
      )}
    </div>
  );
}
